package com.eladfinish.bible.contest.screens.chapterComplete.usecases

import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.data.VerseEntity
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.domain.BooksRepository
import com.eladfinish.bible.contest.screens.mikud.MikudRepository
import com.eladfinish.bible.contest.screens.mikud.usecases.GetChaptersInMikudUseCase
import com.eladfinish.bible.contest.utils.MyStringUtils
import com.eladfinish.bible.contest.utils.RegexUtils
import kotlinx.coroutines.Dispatchers

class SortVersesByMikudUseCase(
    private val assetReader: AssetReader,
    private val buildVerseEntitiesFromChapterUseCase: BuildVerseEntitiesFromChapterUseCase,
    private val mikudRepository: MikudRepository,
    private val getChaptersInMikudUseCase: GetChaptersInMikudUseCase,
) {

    suspend operator fun invoke(
        bookNumber: Int,
    ): MutableList<VerseEntity> {
        val bookFilenamesInMikud = getBookFilenamesInMikud(bookNumber)
        val verseEntities = mutableListOf<VerseEntity>()
        val bookNameHebrew = BooksRepository.bookNamesHebrew[bookNumber - 1]
        bookFilenamesInMikud.forEach {
            val chapterContent = assetReader.readFile(fileName = StringConstants.ALL_CHAPTERS + assetReader.fileSeparator + it.second)
            val onlyContent = RegexUtils.getOnlyContent(chapterContent)
            val isFromSifreyEmet = MyStringUtils.isFromSifreyEmet(bookNameHebrew)
            val verseEntitiesOfChapter = buildVerseEntitiesFromChapterUseCase(
                coroutineContext = Dispatchers.Default,
                bookNumber = bookNumber,
                chapterNumber = it.first,
                chapterContent = onlyContent,
                isFromSifreyEmet = isFromSifreyEmet,
            )
            verseEntities.addAll(verseEntitiesOfChapter)
        }
        return verseEntities
    }

    private fun getBookFilenamesInMikud(indexPickedBook: Int): List<Pair<Int, String>> =
        getChaptersInMikudUseCase(mikudStr = mikudRepository.mikudList, bookNumber = indexPickedBook)

}
